<template>
  <CarruselWeb />

  <!-- 🔍 Buscador -->
  <div class="container row justify-content-center col-12">
    <div
      class="card-body bg-orange p-4 rounded-3 position-relative col-8 shadow-lg"
      style="background-color: #eb802f; margin-top: -70px;"
    >
      <h5 class="text-white fw-bold mb-3">Busca tu destino</h5>
      <div class="row g-2 align-items-center">
        <div class="col-12 col-md-10">
          <input
            type="text"
            v-model="termino"
            @keyup.enter="buscar"
            class="form-control form-control-lg text-dark"
            style="border-radius: 10px;"
            placeholder="Ej. Italia, París, Japón..."
          />
        </div>
        <div class="col-12 col-md-2 mt-2 text-end">
          <button
            @click="buscar"
            class="btn btn-light btn-lg text-dark"
            style="border-radius: 10px;"
          >
            <i class="fa-solid fa-magnifying-glass"></i> Buscar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 🔽 Resultados -->
  <div class="container mt-4" v-if="!loading">
    <div v-if="resultados.length === 0" class="text-center text-danger mt-3">
      No se encontraron resultados.
    </div>

    <!-- Paquetes con paginación -->
    <div class="row col-12">
      <div
        v-for="paquete in paginatedPaquetes"
        :key="paquete.id"
        class="col-md-4 mb-3 my-1"
      >
        <div class="card shadow-sm">
          <div class="row g-0">
            <div class="col-12">
              <img
                :src="`https://beauvoyage.net/${paquete.img}`"
                class="img-fluid rounded-start img-fixed"
                :alt="paquete.nombre"
              />
            </div>

            <div class="col-12">
              <div class="card-body">
                <h5 class="card-title text-primary">{{ paquete.nombre }}</h5>
                <p class="card-text mb-1">
                  <strong>Países:</strong> {{ paquete.paises }}
                </p>
                <p class="card-text mb-1">
                  <strong>Duración:</strong> {{ paquete.duracion }}
                </p>
                <p class="card-text mb-1">
                  <strong>Tarifa:</strong> ${{ paquete.tarifa }} USD
                </p>

                <router-link
                  :to="`/Paquete/${paquete.id}`"
                  class="btn btn-outline-primary mt-2"
                >
                  Detalles del viaje <i class="fa-solid fa-arrow-right"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 🔸 Paginación -->
    <div
      v-if="totalPages > 1"
      class="d-flex justify-content-center mt-4"
    >
      <nav>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="previousPage">Anterior</button>
          </li>

          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <button class="page-link" @click="goToPage(page)">
              {{ page }}
            </button>
          </li>

          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <button class="page-link" @click="nextPage">Siguiente</button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- Loader -->
  <div v-if="loading" class="text-center mt-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>

  <!-- 🔸 Sección informativa -->
  <div
    :class="{ cristal: isActive, 'text-dark': isActive2, 'text-light': isActive3 }"
    class="container"
    style="margin-top: 50px;"
  >
    <h2 class="displayMain mt-5">Ofertas de viajes</h2>
    <p class="displayText mt-5">
      Aprovecha nuestras increíbles ofertas en paquetes de viaje a Europa, Turquía y Sudamérica.<br />
      Incluyen visitas indicadas en el itinerario, alojamiento y desayunos. Viaja acompañado y disfruta de destinos fascinantes con esta promoción especial.
      <b>¡Solicita tu asesoría!</b>
    </p>
    <a class="btn btn-dark btn-lg rounded-4 mt-3 btn-custom" href="#" role="button">Asesoría</a>
    <h2 class="mt-3">Promociones Especiales: ¡Hasta 40% de Descuento!</h2>

    <div class="p-5 mb-4 bg-light text-dark rounded-3">
      <div class="row">
        <div class="col-12 col-md-6">
          <h3>¿Desea contratar un paquete? Sigue estos sencillos pasos.</h3>
          <p class="mt-5"><b>Selecciona tu producto</b></p>
          <p>Paquetes, Translados, Hoteles</p>
          <p class="mt-5"><b>Contáctanos</b></p>
          <p>Mándanos mensaje de WhatsApp dando clic en <b>Contactanos</b></p>
          <p class="mt-5"><b>Si desea asesoría</b></p>
          <p>También puedes solicitar tu asesoría para adaptarnos a tus necesidades y presupuesto.</p>
        </div>

        <div class="col-12 col-md-6 row justify-content-center justify-content-md-end mt-5 mt-md-0">
          <div class="col-12 col-md-8">
            <img src="a2aba42c22089b09ee32c84071cf53ee.png" class="img-fluid rounded-top" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5 mb-5 row justify-content-center col-12" style="position: relative; left: 10px;">
      <div class="col-12 col-md-6 text-center">
        <h5>Agenda tu asesoría</h5>
      </div>
      <div class="col-12 col-md-6 row justify-content-center">
        <div class="col-12 col-md-6 row">
          <button type="button" class="btn btn-dark mt-3 mt-md-0">
            <i class="fa-solid fa-phone"></i> Contactanos
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.img-fixed {
  width: 100%;
  height: 250px;
  object-fit: cover;
  object-position: center;
  border-radius: 0.5rem;
}
</style>

<script>
import axios from "axios";
import CarruselWeb from "./CarruselWeb.vue";

export default {
  name: "HomeWeb",
  components: { CarruselWeb },
  props: ["isActive", "isActive2", "isActive3"],

  data() {
    return {
      paquetes: [],
      termino: "",
      resultados: [],
      loading: false,
      currentPage: 1,
      itemsPerPage: 6,
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.resultados.length / this.itemsPerPage);
    },
    paginatedPaquetes() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.resultados.slice(start, start + this.itemsPerPage);
    },
  },

  methods: {
    tema() {
      this.$emit("update-estadoLogin", {
        isActive: false,
        isActive2: true,
        isActive3: false,
      });
      document.body.style.backgroundColor = "#ffff";
    },

    async traerPaquetes() {
      this.loading = true;
      try {
        const response = await axios.get("https://beauvoyage.net/api/paquetes");
        this.paquetes = response.data;
        this.resultados = response.data;
      } catch (error) {
        console.error("Error al traer los paquetes:", error);
      } finally {
        this.loading = false;
      }
    },

    buscar() {
      const term = this.termino.toLowerCase().trim();
      if (!term) {
        this.resultados = this.paquetes;
      } else {
        this.resultados = this.paquetes.filter(
          (p) =>
            p.nombre.toLowerCase().includes(term) ||
            p.paises.toLowerCase().includes(term)
        );
      }
      this.currentPage = 1; // reinicia a la primera página
    },

    goToPage(page) {
      this.currentPage = page;
    },
    previousPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
  },

  created() {
    this.tema();
    this.traerPaquetes();
  },
};
</script>
